import styled from 'styled-components'

import { TxCountFormatted } from '@root/shared/core/format'
import { useTranslation } from '@root/shared/localization'

import type BigNumber from 'bignumber.js'

export const AnalysisHeaderValue = (props: {
  buys: BigNumber.Value
  sells: BigNumber.Value
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      {t('profile.analysis.txs')}:&nbsp;
      <BuysCount>
        <TxCountFormatted txCount={props.buys} />
      </BuysCount>
      &nbsp;
      <Separator>/</Separator>&nbsp;
      <SellsCount>
        <TxCountFormatted txCount={props.sells} />
      </SellsCount>
    </Root>
  )
}
const Root = styled.div`
  display: flex;
  color: var(--text-11);
`
const BuysCount = styled.div`
  color: var(--up-9);
`
const SellsCount = styled.div`
  color: var(--down-9);
`
const Separator = styled.div`
  color: var(--text-9);
`
